import {InfoService} from "./classes/infoService/InfoService";
import {IInfoServiceRequest} from "./classes/infoService/IInfoServiceRequest";
import {Profile} from "./classes/profile/Profile";
import {BBErrors} from "./classes/errors/BBErrors";
import {PHPSendErrorHandler} from "./classes/errors/handlers/PHPSendErrorHandler";
import {PHPSendLogsHandler} from "./classes/errors/handlers/PHPSendLogsHandler";
import {EventChangeFiles} from './classes/profile/Events/EventChangeFiles';
import {PhotosRender} from "./classes/profile/Renders/PhotosRender";
import {City} from "./classes/city/City";
import {Loader} from "../loader/Loader";
import {BBScriptsInterface} from "./BBScriptsInterface";
import {Forms} from "./classes/forms/Forms";
import {Normolizer} from "./classes/forms/Normolizer";
import {CityInterface} from "./classes/city/CityInterface";
import {Document} from "./classes/window/Document";

export class BBScripts implements BBScriptsInterface {

    public loader: Loader
    public forms: Forms
    public errors: BBErrors
    public logs: BBErrors
    public normolizer: Normolizer
    public DOM: Document

    constructor() {
        this.loader = new Loader();
        this.forms = new Forms();
        this.normolizer = new Normolizer();
        this.logs = new BBErrors(new PHPSendLogsHandler());
        this.DOM = new Document();
        this.initProfile();
        this.initErrorHandler();
    }

    private initProfile(): void {
        new InfoService((response: IInfoServiceRequest) => {
            try {
                let citiesEls = document.querySelectorAll('.widgetProfile + div');
                if (citiesEls) {
                    let profile = new Profile(citiesEls);
                    profile.addEvent(new EventChangeFiles());
                    profile.render(new PhotosRender(response.isPhoto));
                }
            } catch (e) {
                this.logs.send('error init profile');
            }
            this.initCity(response.city);
        });
    }

    private initErrorHandler(): void {
        try {
            this.errors = new BBErrors(new PHPSendErrorHandler());
            this.errors.watch();
        } catch (e) {
            this.logs.send('error init ErrorHandler');
        }
    }

    private initCity(cityInfo: CityInterface): void {
        if (!cityInfo) {
            return;
        }
        try {
            let cities = document.querySelectorAll('.mycity');
            if (cities.length > 0) {
                let city = new City(cities);
                city.setCity(cityInfo);
                city.render();
            }
        } catch (e) {
            this.logs.send('error init city');
        }
    }

}